import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { DataProvider } from './contexts/DataContext';
import { WeatherProvider } from './contexts/WeatherContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import WaterTestLog from './pages/WaterTestLog';
import FeedingLog from './pages/FeedingLog';
import GrowthTracker from './pages/GrowthTracker';
import Timeline from './pages/Timeline';
import MaintenanceLog from './pages/MaintenanceLog';
import ImageLog from './pages/ImageLog';

function App() {
  return (
    <DataProvider>
      <WeatherProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/water-test" element={<WaterTestLog />} />
              <Route path="/feeding" element={<FeedingLog />} />
              <Route path="/growth" element={<GrowthTracker />} />
              <Route path="/timeline" element={<Timeline />} />
              <Route path="/maintenance" element={<MaintenanceLog />} />
              <Route path="/images" element={<ImageLog />} />
            </Routes>
          </Layout>
        </Router>
      </WeatherProvider>
    </DataProvider>
  );
}

export default App;